
export type OutputObject = { [key: string]: any };

export class MetadataObjectBuilder {

    public static set(record: OutputObject, path: string, value: any) {

        if (!path) return;

        // Convert the path to an array if not already
        const segments = this.stringToPath(path);

        // Cache the segments length and current spot in the object
        var length = segments.length;
        var current = record;

        // Loop through the segments
        segments
            .forEach((key, index) => {

                // If this is the last item in the loop, assign the value
                if (index === length - 1) {
                    current[key] = value;
                }

                // Otherwise, update the current place in the object
                else {

                    // If the key doesn't exist, create it
                    if (!current[key]) {
                        current[key] = {};
                    }

                    // Update the current place in the objet
                    current = current[key];

                }

            });

    };

    private static stringToPath(path: string): string[] {

        // If the path isn't a string, return it
        if (typeof path !== 'string') return path;

        // Create new array
        var output = [];

        // Split to an array with dot notation
        path.split('.')
            .forEach((item, index) => {

                // Split to an array with bracket notation
                item.split(/\[([^}]+)\]/g)
                    .forEach(function (key) {

                        // Push to the new array
                        if (key.length > 0) {
                            output.push(key);
                        }

                    });

            });

        return output;

    };

}